import { it } from 'date-fns/locale'
import React, { forwardRef } from 'react'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import MaskedInput from 'react-text-mask'
import styled from 'styled-components'

import { Input } from '../Input'

export type DatePickerProps = {
  id?: string
  name?: string
  value: Date | null
  onChange: (newDate: Date | null) => void
  withMaskedInput?: boolean
  placeholderText?: string
  minDate?: Date | null
  maxDate?: Date | null
  isClearable?: boolean
  invalid?: boolean
  disabled?: boolean
  className?: string
}

export const DatePicker = forwardRef<() => ReactDatePicker, DatePickerProps>(
  (
    {
      id,
      name,
      value,
      onChange,
      placeholderText,
      minDate,
      maxDate,
      isClearable,
      invalid,
      disabled = false,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <DatePickerWrapper className={className}>
        <ReactDatePicker
          locale={it}
          fixedHeight
          dateFormat={'dd/MM/yyyy'}
          isClearable={isClearable}
          selected={value}
          onChange={onChange}
          placeholderText={placeholderText}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ref={ref as any} // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/28884
          customInput={
            <MaskedInput
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              render={(ref, props) => {
                return (
                  <Input
                    ref={ref}
                    {...props}
                    type='text'
                    invalid={invalid}
                    id={id}
                    name={name}
                  />
                )
              }}
              {...rest}
            />
          }
        />
      </DatePickerWrapper>
    )
  }
)

DatePicker.displayName = 'DatePicker' // Typescript workaround for ForwardRef Component

const DatePickerWrapper = styled.div`
  //Override Datepicker Library Style

  .react-datepicker-wrapper {
    display: block;
  }

  .react-datepicker__input-container {
    //Nothing to override
  }
`
